import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import {
  DrawerClose,
  DrawerDescription,
  DrawerTitle,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import SuccessImage from "assets/images/success.png";

export default function Success() {
  const isDesktop = useTwBreakpoint("lg");

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;
  const Close = isDesktop ? DialogClose : DrawerClose;

  return (
    <>
      <img
        src={SuccessImage}
        width={364}
        height={254}
        className="mx-auto mb-4"
        alt=""
      />

      <Title>Your subscription has been updated!</Title>

      <Description className="mb-8">
        Subscription updated successfully. You can always review your current
        subscription in your Workspace settings
      </Description>

      <Close asChild>
        <Button className="ml-auto" variant="secondary-black">
          Continue
        </Button>
      </Close>
    </>
  );
}
